import { Wrapper } from './Styled'

export default function VIP() {
  return <Wrapper />
}
